import { NotificationCenter } from '@/components/notifications';

export function NotificationButton() {
  return (
    <NotificationCenter className="h-9 w-9 rounded-lg hover:bg-muted/50 transition-all duration-200" />
  );
} 